<template>
    <div class="space-y-8">
        <section class="space-y-6">
            <div class="flex space-x-6">
                <nio-input-group class="flex-1" :label="$t('configs.rightPanel.profile.firstName')">
                    <nio-input :required="true" :value="user.first_name" @input="onInput('first_name', $event)" />
                </nio-input-group>
                <nio-input-group class="flex-1" :label="$t('configs.rightPanel.profile.lastName')">
                    <nio-input :required="true" :value="user.last_name" @input="onInput('last_name', $event)" />
                </nio-input-group>
            </div>

            <div class="flex space-x-6">
                <nio-input-group :class="showActive ? 'flex-1' : 'w-1/2 pr-3'" :label="$t('configs.rightPanel.profile.email')">
                    <nio-input :required="true" :value="user.email" @input="onInput('email', $event)" />
                </nio-input-group>
                <nio-input-group class="flex-1" :label="$t('configs.rightPanel.users.active')" v-if="showActive">
                    <nio-toggle :value="user.active" @input="onInput('active', $event)">
                        <span v-text="activeText" />
                    </nio-toggle>
                </nio-input-group>
            </div>
        </section>

        <section>
            <h2 class="flex items-center text-xl mb-4">
                <nio-icon class="mr-2" name="regular/Earth Setting" />
                {{ $t('configs.rightPanel.profile.subtitles.localization') }}
            </h2>
            <div class="flex space-x-6">
                <nio-input-group class="flex-1" :label="$t('configs.rightPanel.profile.locale')">
                    <nio-select
                        :options="locales"
                        :value="user.locale"
                        @input="onInput('locale', $event)"
                    />
                </nio-input-group>
                <nio-input-group class="flex-1" :label="$t('configs.rightPanel.profile.timezone')">
                    <nio-select
                        list-class-name="max-h-40"
                        :options="timezones"
                        :value="user.timezone"
                        @input="onInput('timezone', $event)"
                    />
                </nio-input-group>
            </div>
        </section>

        <section>
            <h2 class="flex items-center text-xl mb-4">
                <nio-icon class="mr-2" name="regular/login-key" />
                {{ inEditMode ? $t('configs.rightPanel.profile.subtitles.changePassword') : $t('configs.rightPanel.profile.subtitles.createPassword') }}
            </h2>
            <div class="flex space-x-6">
                <nio-input-group class="flex-1" :label="$t('configs.rightPanel.profile.password')">
                    <nio-input
                        type="password"
                        :value="user.password"
                        @input="onInput('password', $event)"
                    />
                </nio-input-group>
                <nio-input-group class="flex-1" :label="$t('configs.rightPanel.profile.confirm')">
                    <nio-input
                        type="password"
                        :value="user.password_confirmation"
                        @input="onInput('password_confirmation', $event)"
                    />
                </nio-input-group>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import cloneDeep from 'lodash/cloneDeep';

    export default {
        props: {
            value: {
                type: Object,
                default: () => ({}),
            },
            inEditMode: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                user: {},
                locales: [
                    {
                        value: 'fr',
                        label: 'Français',
                    },
                    {
                        value: 'en',
                        label: 'English',
                    },
                ],
            };
        },

        computed: {
            ...mapGetters([
                'timezones',
            ]),

            ...mapState([
                'authUser',
            ]),

            showActive() {
                return this.inEditMode &&
                    typeof this.user.active !== 'undefined' &&
                    this.user.id != this.authUser.id;
            },

            activeText() {
                return this.user.active
                    ? this.$t('configs.rightPanel.users.userModal.isActive')
                    : this.$t('configs.rightPanel.users.userModal.isNotActive');
            },
        },

        watch: {
            value: {
                immediate: true,
                deep: true,
                handler(user) {
                    this.user = cloneDeep(user);
                },
            },
        },

        methods: {
            onInput(key, value) {
                const updated = {};

                updated[key] = value;

                this.$emit('input', { ...this.user, ...updated });
            },
        },
    };
</script>
